module.exports = __webpack_public_path__ + "img/ZA.729bb91d.png";